/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookie'
import Auth from './packages/auth/Auth.js'
import router from './router'
import store from './store'
import ProviderAuth from './packages/provider/PureCloud'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser as farUser, faEnvelope as farEnvelope, faBuilding as farBuilding } from '@fortawesome/free-regular-svg-icons'
import { faMicrophone, faCopy, faTrash, faEdit, faShoppingCart, faFileUpload, faPlusCircle, faQuestionCircle, faBars, faFileAlt, faFileAudio, faCaretRight, faCaretLeft, faPlay, faPause, faStepBackward, faUser, faLock, faTasks, faSpinner, faCircle, faFileInvoice, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import SlideUpDown from 'vue-slide-up-down'

import App from './App'

library.add(faMicrophone, faCopy, faEdit, faPlusCircle, faTrash, faShoppingCart, faQuestionCircle, faBars, faFileAlt, faFileAudio, faCaretRight, faCaretLeft, faPlay, faFileUpload,
    faPause, faStepBackward, faUser, faCircle, faLock, faFileInvoice, faClipboardList, faTasks, faFacebookF, faTwitter, faLinkedinIn, faYoutube, faSpinner, farUser, farEnvelope, farBuilding)

require('./bootstrap')

window.Vue = require('vue') 

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueCookie)
Vue.use(Auth, {router: router, store: store })
Vue.use(Vuex)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('main-header', require('./components/Header.vue'))
Vue.component('slide-up-down', SlideUpDown)

Vue.use(ProviderAuth, router)

function getParameterByName (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    var results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

router.beforeEach(
    (to, from, next) => {
        /* if (getParameterByName('code') != null && !Vue.provider.isAuthenticated()) {
            Vue.auth.authorize(getParameterByName('code'), () => {
                next('/project')
            })
        }

        if (getParameterByName('iframe') != null) {
            store.commit('setIframe')
        } */        

        if (to.matched.some(record => record.meta.forVisitors)) {
            if (Vue.auth.isAuthenticated()) {
                next({path: '/projects'})
            } else next()
        } else {
            if (!Vue.auth.isAuthenticated()) {
                next({path: '/login'})
            } else {
                Vue.auth.getUser()
                    .then(user => {
                        next()
                    })
            }
        }
    }
)



window.GMV = Object.freeze({
    name: 'GMV eCommerce',
    provider_id: 1,
    version: '1.9.8'
})

window.APPLICATION_MODE = false

if (typeof window.Provider !== 'undefined' && window.Provider.referer === 'https://apps.mypurecloud.com/directory/') {
    store.commit('setIframe')
}

store.commit('setPricing', window.Provider.packages[0])

Vue.axios.defaults.baseURL = 'https://' + process.env.API_URL + '/' + process.env.API_VERSION

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('passport-clients', require('./components/passport/Clients.vue'))
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue'))
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue'))

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
})

window.onload = function () {
    let win = document.getElementById('website-iframe').contentWindow;
    let obj = {
        token: localStorage.getItem('token'),
        expiration: localStorage.getItem('expiration')
    };
    
    win.postMessage(JSON.stringify({key: 'auth', data: obj}), '*')
}


//////////////////
// WEBPACK FOOTER
// ./prompts/main.js
// module id = null
// module chunks = 